var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('page-renderer',{attrs:{"name":_vm.item.options.name}}),(_vm.isRemovable)?_c('span',{staticClass:"remove",on:{"click":function($event){return _vm.removeItem(_vm.item.i)}}},[_vm._v("x")]):_vm._e()],1)}
var staticRenderFns = []

export { render, staticRenderFns }